((Drupal) => {
  Drupal.behaviors.frontpageAkhbarTabs = {
    attach: (context, _settings) => {
      const linksUl = context.querySelector('#akhbar-type-links');
      if (linksUl === null || linksUl.classList.contains('frontpage-tabs-processed')) {
        return;
      }
      linksUl.classList.add('frontpage-tabs-processed');

      const links = linksUl.getElementsByClassName('btn');
      const panes = document.getElementsByClassName('akhbar-pane');

      if (links.length === 0 || panes.length === 0) {
        return;
      }

      const switchPane = (paneNumber) => {
        if (!links[paneNumber]) {
          return '';
        }
        const akhbarType = links[paneNumber].getAttribute('data-akhbar-type');
        const akhbarPaneClass = `akhbar-pane-${akhbarType}`;

        for (let i = 0; i < links.length; i++) {
          links[i].classList.remove('active');
        }
        links[paneNumber].classList.add('active');

        for (let i = 0; i < panes.length; i++) {
          panes[i].style.display = panes[i].classList.contains(akhbarPaneClass) ? 'block' : 'none';
        }

        return akhbarType;
      };

      // Determine initial tab from URL hash
      let initialTab = 0;
      if (window.location.hash) {
        const hash = window.location.hash.substring(1);
        for (let i = 0; i < links.length; i++) {
          if (links[i].getAttribute('data-akhbar-type') === hash) {
            initialTab = i;
            break;
          }
        }
      }

      // Hide all panes initially
      for (let i = 0; i < panes.length; i++) {
        panes[i].style.display = 'none';
      }

      // Activate the initial tab
      switchPane(initialTab);

      // Add click handlers to buttons
      for (let i = 0; i < links.length; i++) {
        links[i].onclick = (e) => {
          e.preventDefault();
          const akhbarType = switchPane(i);
          history.pushState({ tabNumber: i }, '', `#${akhbarType}`);
        };
      }

      // History navigation (back/forward)
      window.onpopstate = (event) => {
        const tabNumber = event.state ? event.state.tabNumber : 0;
        switchPane(tabNumber);
      };
    },
  };
})(window.Drupal);
